/**
 * Deadline presets used by GDPR category options.
 */
export const INCIDENT_DEADLINES = [
    {
        label: '1 Hour (Immediate)',
        value: 1
    },
    {
        label: '4 Hours (Critical)',
        value: 4
    },
    {
        label: '8 Hours (High Priority)',
        value: 8
    },
    {
        label: '24 Hours (1 Day)',
        value: 24
    },
    {
        label: '48 Hours (2 Days)',
        value: 48
    },
    {
        label: '72 Hours (GDPR Recommended)',
        value: 72
    },
    {
        label: '96 Hours (4 Days)',
        value: 96
    },
    {
        label: '120 Hours (5 Days)',
        value: 120
    },
    {
        label: '168 Hours (1 Week)',
        value: 168
    },
    {
        label: 'Custom',
        value: 'custom'
    }
];

export const CATEGORY_QUESTION_TYPE = 'category';

/**
 * Fixed option type for all category options.
 * Users cannot change this — there is no type selector in the Designer UI.
 */
export const CATEGORY_OPTION_DEFAULT_TYPE = 'checkbox';
